import { Card, Tabs, Typography } from 'antd';
import { BgColorsOutlined, AppstoreOutlined, SettingOutlined } from '@ant-design/icons';
import AppearanceSettings from '../../components/AppearanceSettings';
import AppConfigurationSettings from '../../components/AppConfigurationSettings';

const { Title, Text } = Typography;

export default function FeedbackSettings() {
  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ marginBottom: 8 }}>
          Feedback Settings
        </Title>
        <Text type="secondary">
          Configure your Feedback application appearance, sidebar, and preferences
        </Text>
      </div>

      <Card>
        <Tabs
          defaultActiveKey="appearance"
          items={[
            {
              key: 'appearance',
              label: (
                <span>
                  <BgColorsOutlined />
                  Appearance
                </span>
              ),
              children: (
                <div style={{ padding: 16 }}>
                  <AppearanceSettings />
                </div>
              ),
            },
            {
              key: 'sidebar',
              label: (
                <span>
                  <AppstoreOutlined />
                  Sidebar Configuration
                </span>
              ),
              children: (
                <div style={{ padding: 16 }}>
                  <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
                    Manage your Feedback application sidebar menu items. Drag and drop to reorder, toggle to enable/disable items.
                  </Text>
                  <AppConfigurationSettings
                    applicationFilter="feedback"
                    defaultApplication="feedback"
                  />
                </div>
              ),
            },
            {
              key: 'general',
              label: (
                <span>
                  <SettingOutlined />
                  General
                </span>
              ),
              children: (
                <div style={{ padding: 16 }}>
                  <Title level={4}>General Feedback Settings</Title>
                  <Text type="secondary">
                    General feedback application settings and preferences will be implemented here.
                  </Text>
                </div>
              ),
            },
          ]}
        />
      </Card>
    </div>
  );
}
